// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mihwridhatjxxovnvxca.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1paHdyaWRoYXRqeHhvdm52eGNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjA3MjE4ODAsImV4cCI6MjAzNjI5Nzg4MH0.Cay-TphNvC8X0lR05j_NEP-AAZXroE1hQv8xJmCKBF8'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)